import { toggleSidebarMenu } from '@app/store/reducers/ui';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Switch } from 'react-router-dom';

import AccessLogHistory from '@pages/accesslog/AccessLogHistory';
import Blank from '@pages/Blank';
import CandidateDetail from '@pages/candidate/detail/CandidateDetail';
import CandidateList from '@pages/candidate/list/CandidateList';
import CreatePerson from "@pages/candidate/userinput/CreatePerson";
import UploadCV from '@pages/candidate/userinput/UploadCV';
import Dashboard from '@pages/Dashboard';
import DictContentList from '@pages/dictionary/DictContentList';
import DictKeywordList from '@pages/dictionary/DictKeywordList';
import StandardList from '@pages/dictionary/StandardList';
import Profile from '@pages/profile/Profile';

import DVTJCUVReceiverSummaryManager from '@app/pages/dvtjcuv/DVTJCUVReceiverSummaryManager';
import CddNeedFuList from "@pages/candidate/cddneedfu/CddNeedFuList";
import CandidateInputInfoSearch from "@pages/candidate/list/CandidateInputInfoSearch";
import UploadExcel from "@pages/candidate/userinput/UploadExcel";
import CddSddvManager from "@pages/dvtjcuv/list/cddsddv/CddSddvManager";
import CandidateJobChangeList from "@pages/dvtjcuv/list/DVTJCUVPipelineList";
import AcquireCddManager from "@pages/dvtjcuv/rundvtjcuv/accquirecdd/AcquireCddManager";
import CddOpenAndNotSddvManager from "@pages/dvtjcuv/rundvtjcuv/cddopenandnotsddv/CddOpenAndNotSddvManager";
import ConnectCddEmpManager from "@pages/dvtjcuv/rundvtjcuv/connectcddemp/ConnectCddEmpManager";
import SearchCddManager from "@pages/dvtjcuv/rundvtjcuv/search/SearchCddManager";
import WorkWithRecManager from "@pages/dvtjcuv/workwithrec/WorkWithRecManager";
import SearchEmployerPipelineManager from '@pages/dvtjcuv/rundvtjcuv/search/SearchEmployerPipelineManager';
import DVTJCUVTemplateListManager from "@pages/email/template/dvtjcuv/DVTJCUVTemplateListManager";
import InviteJobTemplateListManager from "@pages/email/template/invitejob/InviteJobTemplateListManager";
import MailTemplateList from "@pages/email/template/list/MailTemplateList";
import SignatureMailTemplateList from "@pages/email/template/signature/SignatureMailTemplateList";
import YourMailManager from "@pages/email/YourMailManager";
import CampaignList from "@pages/Campaign/CampaignList";
import CampaignDetail from "@pages/Campaign/CampaignDetail";
import EditEmployer from "@pages/employer/edit/EditEmployer";
import EmployerList from "@pages/employer/list/EmployerList";
import EditJob from "@pages/job/edit/EditJob";
import JobList from "@pages/job/list/JobList";
import RunJobList from "@pages/job/runjob/RunJobList";
import JobPipeLineList from "@pages/jobpipeline/list/JobPipeLineList";
import Notifications from "@pages/notification/Notifications";
import SaveListManager from "@pages/savedlist/SaveListManager";
import MemberList from "@pages/user/MemberList";
import Footer from './footer/Footer';
import Header from './header/Header';
import MenuSidebar from './menu-sidebar/MenuSidebar';


const Main = () => {
    const dispatch = useDispatch()
    const isSidebarMenuCollapsed = useSelector(
        (state) => state.ui.isSidebarMenuCollapsed
    );
    const screenSize = useSelector((state) => state.ui.screenSize);
    const [isAppLoaded, setIsAppLoaded] = useState(false);

    const handleToggleMenuSidebar = () => {
        dispatch(toggleSidebarMenu())
    };

    useEffect(() => {
        document.getElementById('root').classList.remove('register-page');
        document.getElementById('root').classList.remove('login-page');
        document.getElementById('root').classList.remove('hold-transition');
        document.getElementById('root').classList.add('sidebar-mini');
        document.getElementById('root').classList.add('layout-fixed');

        return () => {
            document.getElementById('root').classList.remove('sidebar-mini');
            document.getElementById('root').classList.remove('layout-fixed');
        };
    }, []);

    useEffect(() => {
        document.getElementById('root').classList.remove('sidebar-closed');
        document.getElementById('root').classList.remove('sidebar-collapse');
        document.getElementById('root').classList.remove('sidebar-open');
        if (isSidebarMenuCollapsed && screenSize === 'lg') {
            document.getElementById('root').classList.add('sidebar-collapse');
        } else if (isSidebarMenuCollapsed && screenSize === 'xs') {
            document.getElementById('root').classList.add('sidebar-open');
        } else if (!isSidebarMenuCollapsed && screenSize !== 'lg') {
            document.getElementById('root').classList.add('sidebar-closed');
            document.getElementById('root').classList.add('sidebar-collapse');
        }
    }, [screenSize, isSidebarMenuCollapsed]);

    const getAppTemplate = useCallback(() => {
        // if (!isAppLoaded) {
        //     return <PageLoading />;
        // }
        return (
            <>
                <Header toggleMenuSidebar={handleToggleMenuSidebar} />
                <MenuSidebar />
                <div className="content-wrapper">
                    <div className="pt-3" />
                    <section className="content">
                        <Switch>
                            <Route exact path="/sub-menu-2" component={Blank} />
                            <Route
                                exact
                                path="/candidate/cv/upload"
                                component={UploadCV}
                            />
                            <Route
                                exact
                                path="/candidate/excel/upload"
                                component={UploadExcel}
                            />
                            <Route
                                exact
                                path="/person/create"
                                component={CreatePerson}
                            />
                            <Route
                                exact
                                path="/candidate/list"
                                component={CandidateList}
                            />
                            <Route
                                exact
                                path="/cdd-need-fu/list"
                                component={CddNeedFuList}
                            />
                            <Route
                                exact
                                path="/saved-list"
                                component={SaveListManager}
                            />
                            <Route
                                exact
                                path="/candidate/detail/:candidateId"
                                component={CandidateDetail}
                            />
                            <Route
                                exact
                                path="/extract-content-dict/list"
                                component={DictContentList}
                            />
                            <Route
                                exact
                                path="/extract-keyword-dict/list"
                                component={DictKeywordList}
                            />
                            <Route
                                exact
                                path="/standard-dict/list"
                                component={StandardList}
                            />
                            <Route
                                exact
                                path="/candidate/input-info"
                                component={MemberList}
                            />
                            <Route
                                exact
                                path="/candidate/input-info/:candidateId"
                                component={CandidateInputInfoSearch}
                            />
                            <Route
                                exact
                                path="/member/list"
                                component={MemberList}
                            />
                            {/*<Route*/}
                            {/*    exact*/}
                            {/*    path="/keyword-dict/list"*/}
                            {/*    component={DictKeywordList}*/}
                            {/*/>*/}
                            <Route
                                exact
                                path="/accesslog-history"
                                component={AccessLogHistory}
                            />
                            <Route
                                exact
                                path="/notifications"
                                component={Notifications}
                            />
                            <Route exact path="/profile" component={Profile} />
                            <Route exact path="/" component={Dashboard} />
                            <Route exact path="/employer/list" component={EmployerList} />
                            <Route exact path="/employer/add" component={EditEmployer} />
                            <Route exact path="/employer/edit/:employerId" component={EditEmployer} />
                            <Route exact path="/job/list" component={JobList} />
                            <Route exact path="/run-job/list" component={RunJobList} />
                            <Route exact path="/job/add" component={EditJob} />
                            <Route exact path="/job/edit/:jobId" component={EditJob} />
                            <Route exact path="/job/pipeline/list" component={JobPipeLineList}/>

                            <Route exact path="/dvtjcuv/list" component={CandidateJobChangeList}/>
                            <Route exact path="/dvtjcuv/acquire-cdd" component={AcquireCddManager}/>
                            <Route exact path="/dvtjcuv/connect-cdd-emp" component={ConnectCddEmpManager}/>
                            <Route exact path="/dvtjcuv/cdd-open-and-not-sddv" component={CddOpenAndNotSddvManager}/>
                            <Route exact path="/dvtjcuv/search-cdd-receiver" component={SearchCddManager} />
                            <Route exact path="/dvtjcuv/receiver-summary" component={DVTJCUVReceiverSummaryManager} />
                            <Route exact path="/dvtjcuv/search-employer" component={SearchEmployerPipelineManager} />
                            <Route exact path="/dvtjcuv/cdd-sddv" component={CddSddvManager} />
                            <Route exact path="/dvtjcuv/work-with-recs" component={WorkWithRecManager} />

                            <Route exact path="/mail/template/list" component={MailTemplateList}/>
                            <Route exact path="/mail/signature-temp/list" component={SignatureMailTemplateList}/>
                            <Route exact path="/mail/invite-job-temp/list" component={InviteJobTemplateListManager}/>
                            <Route exact path="/mail/dvtjcuv-temp/list" component={DVTJCUVTemplateListManager}/>
                            <Route exact path="/mail/template/edit/:templateId" component={EditJob} />
                            <Route exact path="/mail/your-mail/list" component={YourMailManager} />
                            <Route exact path="/mail/campaign/list" component={CampaignList} />
                            <Route exact path="/mail/campaign/detail/:campaignId" component={CampaignDetail} />
                        </Switch>
                    </section>
                </div>
                <Footer />
                <div
                    id="sidebar-overlay"
                    role="presentation"
                    onClick={handleToggleMenuSidebar}
                    onKeyDown={() => {}}
                />
            </>
        );
    }, [isAppLoaded]);

    return <div className="wrapper">{getAppTemplate()}</div>;
};

export default Main;
